import React, { Fragment } from 'react'

import {
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardText,
    List,
    Table,
    ListInlineItem,
    Col
} from 'reactstrap';
import ApplyRoleButton from './ApplyRoleButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShield } from '@fortawesome/free-solid-svg-icons';
import StepCard from './RoleRegistration/StepCard';

function RoleDescriptionSectionCard({
    sectionData = {},
    roleId,
    isRegistrationOpen,
    isRoleCapped,
    submissionStatus = 'idle',
    isApplyDisabled = true,
    scrollToSection = () => null,
    onApply = () => null,
    showConfirmModal
}) {
  const {
    id: sectionId,
    title,
    displayTitle,
    subtitle,
    description,
    contentItems = [],
    highlights = [],
    lists = [],
    tables = [],
    moreItems = [],
    cards = [],
    tiles = []
} = sectionData;

  const getTextParts = textValue => textValue.split(/(\*\*.*?\*\*)/g);

  const handleOverviewApplyClicked = () => {
    if (isApplyDisabled) {
        scrollToSection('joinNow');
        return;
    }
    
    onApply();
  };

  const headerContent = (
    <>
        <FontAwesomeIcon fixedWidth size="4x" icon={faShield} />

        <div>
            <CardTitle tag="h3" className="h3 mb-1 text-capitalize border-bottom border-primary-orange-subtle bangers-regular text-light sfb-subtitle">
                {displayTitle || title}
            </CardTitle>

            <CardSubtitle tag="h6" className="sfb-subtitle pt-2 mb-0 text-primary-orange">
                {subtitle}
            </CardSubtitle>
        </div>
    </>
);

  return (
    <StepCard headerContent={headerContent}>
        {highlights.length > 0 && (
            <List type="inline" className="d-flex flex-column flex-lg-row align-items-center justify-content-around gap-2 gap-lg-4 py-2 mx-5 mb-3 rounded-3 bg-darker-50 border border-primary-orange-subtle text-light shadow-xs">
                {highlights.map(text => (
                    <ListInlineItem key={`list-item-${text}`} className="m-0 sfb-tertiary-title sigmar-regular fw-normal">
                        {text}
                    </ListInlineItem>
                ))}
            </List>
        )}

        {description && (
            <div className="mb-3">                
                {description.split(' Spitface Battles').map((textValue, index, arr) => (
                    <Fragment key={`section-description-item-${textValue}`}>
                        <span className="text-light">{textValue}</span>&nbsp;
                        {index < arr.length - 1 && (
                            <>
                                <strong className="d-inline-block text-primary-orange-emphasis fw-normal sfb-inline anton-regular">
                                    Spitface Battles
                                </strong>
                            </>
                        )}
                    </Fragment>
                ))}
            </div>
        )}

        {cards.length > 0 && (
            <div className="d-flex flex-wrap gap-3">
                {cards.map(({ id, title, icon, items = [] }) => (
                    <Card key={`why-card-${id}`} className="same-flex-width bg-darker-25 border border-primary-orange-subtle surface-elevated shadow-xs">
                        <CardBody className="p-2">
                            <div className="d-flex flex-column align-items-center gap-1">
                                <FontAwesomeIcon fixedWidth icon={icon} size="2x" className="my-1 text-primary-orange-emphasis" />
                                <CardText className="fs-5 fw-semibold text-light text-center sfb-subtitle annie-use-your-telescope-regular">
                                    {title}
                                </CardText>
                            </div>

                            <List className="px-0">
                                {items.map(textValue => (
                                    <CardText key={`card-item-${textValue}`} className="mb-0 small text-secondary text-center">
                                        {textValue}
                                    </CardText>
                                ))}
                            </List>

                        </CardBody>
                    </Card>
                ))}
            </div>
        )}


        {moreItems.length > 0 && (
            <div>
                <CardText tag="h3" className="sfb-title text-light fw-normal fs-1 text-center my-3 anton-regular">
                    What It Takes
                </CardText>

                <div className="row bg-darkest border-top border-bottom border-primary-orange-subtle">
                    {moreItems.map(({ key, label, icon }, index) => (
                        <Col key={`expectation-${key}`} xs="6" lg="3" className="gy-3 pb-3">
                            <div className={`same-flex-width px-2 text-center surface-elevated py-3 rounded-pill border-primary-orange-subtle`}>
                                <FontAwesomeIcon fixedWidth size="2x" icon={icon} className="mb-2 text-primary-orange-emphasis" />
                                <CardText className="px-2 text-light mb-0 sfb-tertiary-title anton-regular">
                                    {label}
                                </CardText>
                            </div>
                        </Col>
                    ))}
                </div>
            </div>
        )}

        {sectionId === 'overview' && (
            <ApplyRoleButton
                roleId={roleId}
                data-id={roleId}
                isRegistrationOpen={isRegistrationOpen}
                isRoleCapped={isRoleCapped}
                submissionStatus={submissionStatus}
                isDisabled={false}
                onApply={handleOverviewApplyClicked}
                showConfirmModal={showConfirmModal}
                className="d-block mx-auto mt-4"
            />
        )}

        {tiles.length > 0 && (
            <div className="row g-3">
                {tiles.map(({ id, icon, title, label }) => (
                    <Col xs={id === 'official' ? '12' : '6'} key={`action-tiles-${title}`}>
                        <div className={`h-100 rounded-3 p-3 text-center surface-elevated ${id === 'official' ? 'mx-5 border-primary-orange-subtle' : ''}`}>
                            <FontAwesomeIcon icon={icon} size={id === 'official' ? '4x' : '2x'} className="mb-2 text-primary-orange" />
                            <p className={`fw-normal sfb-subtitle text-light sigmar-regular ${id === 'official' ? 'fs-4' : ''}`}>{title}</p>
                            <p className={`small text-secondary mb-0 ${sectionId === 'whatYoullGet' ? 'text-justify' : 'text-center'}`}>
                                {label}
                            </p>
                        </div>
                    </Col>
                ))}
            </div>
        )}

        {lists.length > 0 && (
            <div className="d-flex justify-content-center gap-3 gap-lg-5">
                {lists.map(({ title, items = [] }, index) => (
                    <div key={`list-${title}`} className="flex-1 surface-elevated py-2 px-3 rounded-4 shadow-xs">
                        <CardText className="fs-4 fw-bold sfb-tertiary-title text-primary-orange-emphasis">
                            {title}
                        </CardText>
                        <List key={`list-${title}-${index}`}>
                            {items.map(itemValue => (
                                <li key={`list-item-${itemValue}`} className="small">
                                    {itemValue}
                                </li>
                            ))}
                        </List>
                    </div>
                ))}
            </div>
        )}

        {tables.length > 0 && tables.map(({ title, headers = [], rows = [] }) => (
            <div key={`section-table-${title}`} className="mt-4 px-lg-5">
                <Table responsive borderless size="sm" className="requirements-table">
                    <thead>
                        <tr className="">
                            {headers.map((textValue, index0) => (
                                <th key={`section-th-${textValue}`} className={`border-0 lh-sm ${index0 > 0 ? 'border-bottom border-bottom border-primary-orange-subtle' : 'w-15 bg-transparent'}`}>
                                    {textValue.split('\n').map((textLine, index1) => (
                                        <Fragment key={`requirement-th-${textLine}-${textValue}`}>
                                            {index1 === 0 ? (
                                                <h3 className="mb-1 fw-semibold text-center text-uppercase text-primary-orange-emphasis sfb-subtitle annie-use-your-telescope-regular">
                                                    {textLine}
                                                </h3>
                                            ) : (
                                                <small
                                                    key={`requirement-th-${textLine}-${textValue}`}
                                                    className="d-block fw-light text-center text-capitalize sfb-tertiary-title anton-regular"
                                                >
                                                    {textLine}
                                                </small>
                                            )}
                                        </Fragment>
                                    ))}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody className="bg-transparent">
                        {rows.map((row, index) => (
                            <tr key={`section-tr-${index}`} className="border-bottom border-primary-orange-subtle">
                                {Object.keys(row).map(key => (
                                    <Fragment key={`td-${key}-${index}`}>
                                        {(key === 'requirement' || key.includes('phase')) && (
                                            <td className={`text-light border-0 lh-sm ${key === 'requirement' ? 'align-self-end text-end mb-1 bg-transparent' : 'text-center bg-transparent'}`} >
                                                <div className={`${key.includes('phase') ? 'py-1 px-lg-3 px-xl-4' : 'mt-3'}`}>
                                                    <div className={`${key.includes('phase') ? 'p-2 rounded-3 shadow-xs bg-darker-25 surface-elevated' : ''}`}>
                                                        <label className={`d-block ${key === 'requirement' ? 'fw-medium text-primary-orange-emphasis sfb-subtitle bangers-regular' : 'fs-4'}`}>
                                                            {row[key]}
                                                        </label>

                                                        {key === 'requirement' && (
                                                            <small className="sfb-tertiary-title">{row.timeframe}</small>
                                                        )}

                                                        {key.includes('phase') && (
                                                            <small className="">{row.metric}</small>
                                                        )}
                                                    </div>
                                                </div>
                                            </td>
                                        )}
                                    </Fragment>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        ))}

        {sectionId !== 'overview' && contentItems.map(itemValue => (
            <CardText key={`content-item-${itemValue}`} className="text-center mt-3">
                {getTextParts(itemValue).map(value => {
                    if(value.startsWith('**') && value.endsWith('**')) {
                        return <strong key={`text-part-${value}`}>{value.slice(2, -2)}</strong>;
                    }
                    return value;
                })}
            </CardText>
        ))}

        {sectionId === 'joinNow' && (
            <ApplyRoleButton
                roleId={roleId}
                data-id={roleId}
                isRegistrationOpen={isRegistrationOpen}
                isRoleCapped={isRoleCapped}
                submissionStatus={submissionStatus}
                isDisabled={false}
                onApply={onApply}
                showConfirmModal={showConfirmModal}
                className="d-block mx-auto mt-3"
            />
        )}
    </StepCard>
  )
}

export default RoleDescriptionSectionCard